<swal #currentSwal title="Operación" text="Operación realizada" icon="info"></swal>
<swal #notesSwal title="Operación" text="Operación realizada" icon="info"></swal>

<!-- <h1>{{fileIdValue ? fileIdValue: 'Sin id por ruta'}}</h1> -->
<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="app-content content">
	<div class="content-wrapper">
		<div class="content-header row mb-1"></div>
		<div class="content-detached">
			<div class="content-body">
				<!-- insertar barra de busqueda -->

				<app-search-bar
					[criterioPrincipal]="configLocal.barraBusqueda.criterioPrincipal"
					[config]="configLocal.barraBusqueda"
					[filtroEmisor]="true"
					[filtroSucursal]="true"
					[filtroEstadoDte]="true"
					[filtroPais]="true"
					[filtroEstadoSii]="true"
					[filtroDTEExportacion]="true"
					[filtroDTE]="true"
					[filtroPuerto]="true"
					[filtroReutilizado]="true"
					[filtroClausulaVenta]="true"
					[filtroModalidadVenta]="true"
					[nombreCampoDatePicker]="configLocal.barraBusqueda.nombreCampoDatePicker"
					[fechaInicio]="fechaInicioDefault"
					[fechaFin]="fechaFinDefault"
					[useAccordionMode]="true"
					(busqueda)="searchElementsByFilter($event)"
					[listaCompletaEmisores]="empresasSource"
					[mostrarListaCompletaEmisores]="true"
				></app-search-bar>
				<section class="row">
					<div class="col-12">
						<div class="card card-custom">
							<div class="card-header">
								<h4 class="card-title">
									{{ configLocal.table.title
									}}{{
										filterDescription
											? " -
                                    " + filterDescription
											: ""
									}}
								</h4>
								<div class="card-toolbar">
								</div>
							</div>
							<div class="card-head">
								<div class="heading-elements mt-0">
									<button class="btn btn-warning float-right mr-5 mt-5 buttonMantenedor btn-reutilizar" data-gtm-id="reutilizar-folios-masivo" data-gtm-group="dte-exportacion" (click)="tryMassiveRouseConfirm()" ngbTooltip="Solo se pueden reutilizar folios de documentos que no estén aceptados por el sii" *ngIf="permissions.getPermission('40-18-46').asignado">
										<i class="flaticon-download-1"></i>
										Reutilizar Folios Masivo
									</button>
									<button class="btn btn-warning float-right mr-5 mt-5 buttonMantenedor btn-export" data-gtm-id="exportar" data-gtm-group="dte-exportacion" (click)="openExportModal()" ngbTooltip="Exporta tus registros a Excel" *ngIf="permissions.getPermission('40-18-16').asignado">
										<i class="flaticon-download-1"></i>
										Exportar
									</button>
									<div ngbDropdown class="btn-descargar">
										<button ngbDropdownToggle id="dropdownDescargas" class="btn btn-primary float-right mr-5 mt-5" *ngIf="permissions.getPermission('40-18-12').asignado">
											<i class="flaticon-download"></i>
											Descarga Documentos
										</button>
										<div ngbDropdownMenu aria-labelledby="dropdownDescargas">
											<button class="buttonMantenedor" ngbDropdownItem data-gtm-id="descarga-pdf" data-gtm-group="dte-exportacion" (click)="multipleDocumentDownload('pdf')">Descarga PDF</button>
											<button class="buttonMantenedor" ngbDropdownItem data-gtm-id="descarga-xml" data-gtm-group="dte-exportacion" (click)="multipleDocumentDownload('xml')">Descarga XML</button>
										</div>
									</div>
									<button class="btn btn-warning float-right mr-5 mt-5 menu-item buttonMantenedor" data-gtm-id="generar" data-gtm-group="dte-exportacion" (click)="navigateToFacturador(4)" *ngIf="permissions.getPermission('40-19-10').asignado">
										<i class="flaticon-add-circular-button"></i>
										<span class="menu-text">Factura Exportación</span>
									</button>
								</div>
							</div>
							<!-- <div class="col-1" >
                                <ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change) ="setPageSize()">
                                   <option *ngFor="let option of page.pageSizes" [value]="option" ></option>
                                </ng-select>
                           </div> -->
							<div class="card-content">
								<div class="card-body">
									<!-- inicion seccion botones agregar y exportar -->
									<!-- <app-exportacion-datos [dataArray]="rowsMantenedor" [exportCriteria]="criteriosEnBase"></app-exportacion-datos> -->

									<!-- fin seccion botones -->

									<!-- seccion tabla -->
									<ngx-datatable
										#table
										class="material mobile-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="50"
										[rowHeight]="70"
										fxFlex="auto"
										[perfectScrollbar]="configScroll"
										[selectionType]="'checkbox'"
										[selected]="selected"
										(selected)="onSelect($event)"
										[rowIdentity]="getId"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										(sort)="utilities.onSortTable(table, page)"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
										[externalSorting]="false"
										[sortType]="SortType.multi"
									>
										<ngx-datatable-column [width]="40" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
											<ng-template ngx-datatable-header-template let-value="value">
												<input type="checkbox" class="customCheckbox" [checked]="selectedAllItemsInPage[page.pageNumber]" (change)="selectAll($event)" />
											</ng-template>
											<ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected" let-onCheckboxChangeFn="onCheckboxChangeFn">
												<input type="checkbox" class="customCheckbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="nombreTipoDte" [flexGrow]="1" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Tipo</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.nombreTipoDte }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="folio" [flexGrow]="1" [sortable]="true" [resizeable]="false" [cellClass]="'number-table-alignment'" [headerClass]="'number-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="number-table-alignment">Folio</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="number-table-alignment">{{ row.folio }}</span></ng-template
											>
										</ngx-datatable-column>
										<!-- <ngx-datatable-column name="Cliente" [flexGrow]="2" [sortable]="false" [resizeable]="false">
                                        <ng-template let-column="column" ngx-datatable-header-template>
                                            <span class="text-table-alignment">Cliente</span>
                                        </ng-template>
                                        <ng-template ngx-datatable-cell-template let-row="row"><span class="text-table-alignment">{{row.rutReceptorDv?row.rutReceptorDv:"No disponible" }}</span></ng-template>
                                    </ngx-datatable-column> -->
										<ngx-datatable-column name="Razón Social" [flexGrow]="3" [sortable]="false" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Razón Social</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{
													row.razonSocial
														? row.razonSocial
														: "No
                                                    disponible"
												}}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="fecha" [flexGrow]="1.6" [sortable]="true" [resizeable]="false" [cellClass]="'date-table-alignment'" [headerClass]="'date-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="date-table-alignment">Fecha</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="date-table-alignment">{{ row.fecha | date : "dd/MM/yyyy" }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="total" [flexGrow]="2" [sortable]="true" [cellClass]="getCellClass" [resizeable]="false" [headerClass]="'number-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="number-table-alignment">Monto</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span ngbTooltip="{{ row.tipoMoneda }}" class="number-table-alignment">{{ row.total | currency : "$ " : "symbol" : "1.0-2" : "es" }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column [cellTemplate]="semaforo" [sortable]="false" name="Estado" [flexGrow]="1.5" [resizeable]="false"></ngx-datatable-column>
										<ngx-datatable-column name="Acciones" [flexGrow]="4.2" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<a [routerLink]="" ngbTooltip="Enviar correo" class="primary edit mr-1 mrless" id="mantenedor-dte-exportacion.component_Enviar_correo" (click)="openDocumentSenderModal(dteSenderModal, row)" *ngIf="permissions.getPermission('40-18-20').asignado">
													<!-- <span aria-label="Enviar correo" [inlineSVG]="'./assets/media/svg/icons/Communication/Outgoing-mail.svg'" cacheSVG="true" class="svg-icon svg-icon-3x svg-icon-success"></span> -->
													<div class="icon-circle bg-success text-center align-middle pt-email-button">
														<fa-icon icon="envelope" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<div ngbDropdown class="dropdownBotoneraLinea" container="body">
													<a [routerLink]="" title="Descarga Documento" ngbTooltip="Descarga Documento" class="success edit mr-1 mrless" ngbDropdownToggle id="dropdownDoc" container="body" *ngIf="permissions.getPermission('40-18-22').asignado">
														<div class="icon-circle bg-danger text-center align-middle pt-file-button">
															<fa-icon icon="file-pdf" class="fa-lg text-white"></fa-icon>
														</div>
													</a>
													<div ngbDropdownMenu aria-labelledby="dropdownDoc">
														<button ngbDropdownItem (click)="downloadPDF(row)" *ngIf="permissions.getPermission('40-18-22').asignado">Descarga PDF</button>
														<button ngbDropdownItem (click)="downloadXml(row)" *ngIf="permissions.getPermission('40-18-24').asignado">Descargar XML</button>
														<button ngbDropdownItem (click)="downloadMassiveFile(row)" *ngIf="!row.importado && permissions.getPermission('40-10-12').asignado && row.importacionMasivaId != null">Descargar Archivo Importación Masiva</button>
													</div>
												</div>
												<a [routerLink]="" ngbTooltip="Trazabilidad" class="primary edit mr-1 mrless" id="mantenedor-dte-exportacion.component_Trazabilidad" (click)="openTraceShowModal(dteTracesModal, row)" *ngIf="permissions.getPermission('40-18-26').asignado">
													<div class="icon-circle bg-info text-center align-middle pt-list-button">
														<fa-icon icon="list-alt" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a [routerLink]="" ngbTooltip="Detalles" class="primary edit mr-1 mrless" id="mantenedor-dte-exportacion.component_Detalles" (click)="detailOpenModal(dteDetailModal, row)" *ngIf="permissions.getPermission('40-18-28').asignado">
													<div class="icon-circle bg-warning text-center align-middle pt-info-button">
														<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<!-- VERSIONES DE MANTENEDOR DTE EMITIDOS -->
												<a *ngIf="!row.anulado && permissions.getPermission('40-18-30').asignado && row.notaCreditoHabilitada && (row.codigoTipoDte == 110 || row.codigoTipoDte == 111)" [routerLink]="" container="body" ngbTooltip="Generar Nota Credito Exportación" class="danger edit mr-1 mrless" (click)="openAnularDteModal(anularNCDteExportModal, row)">
													<div class="icon-circle bg-danger text-center align-middle pt-null-button">
														<fa-icon icon="file-alt" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a *ngIf="!row.anulado && permissions.getPermission('40-18-31').asignado && row.notaDebitoHabilitada && row.codigoTipoDte == 112" [routerLink]="" container="body" ngbTooltip="Generar Nota Debito Exportación" class="danger edit mr-1 mrless" (click)="openAnularDteModal(anularNDDteExportModal, row)">
													<div class="icon-circle bg-danger text-center align-middle pt-null-button">
														<fa-icon icon="file-alt" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<!-- VERSIONES DE MANTENEDOR DTE EXPORTACION SIN FLAGS "ANULADO" NI "NOTACREDITOHABILITADA"/"NOTADEBITOHABILITADA"-->
												<!-- <a *ngIf="permissions.getPermission('40-18-30').asignado && row.codigoTipoDte == 110"
                                            [routerLink]="" container="body" ngbTooltip="Generar Nota Credito Exportación" class="danger edit mr-1 mrless"
                                            (click)="openAnularDteModal(anularNCDteExportModal,row)">
                                            <div class="icon-circle bg-danger text-center align-middle pt-null-button">
                                                <fa-icon icon="file-alt" class="fa-lg text-white"></fa-icon>
                                            </div>
                                        </a>
                                        <a *ngIf="permissions.getPermission('40-18-31').asignado  && row.codigoTipoDte == 112"
                                            [routerLink]="" container="body" ngbTooltip="Generar Nota Debito Exportación" class="danger edit mr-1 mrless"
                                            (click)="openAnularDteModal(anularNDDteExportModal,row)">
                                            <div class="icon-circle bg-danger text-center align-middle pt-null-button">
                                                <fa-icon icon="file-alt" class="fa-lg text-white"></fa-icon>
                                            </div>
                                        </a> -->
												<a [routerLink]="" ngbTooltip="Reenviar Documento al SII" class="primary edit mr-1 mrless" id="mantenedor-dte-exportacion.component_Reenviar_Documento_al_SII" (click)="resendDte(row)" *ngIf="permissions.getPermission('40-18-38').asignado && row.estadoSii == 8 && !row.folioReutilizado">
													<div class="icon-circle bg-info text-center align-middle pt-info-button">
														<fa-icon icon="recycle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a
													*ngIf="!row.importado && !row.folioReutilizado && permissions.getPermission('40-18-44').asignado && row.reutilizarFoliohabilitado"
													class="primary edit mr-1 mrless"
													ngbTooltip="Reutilizar Folio"
													[swal]="{
														title: 'Confirmación',
														text: 'El folio volvera a estar disponible, ¿Desea Continuar?',
														confirmButtonText: 'Continuar',
														cancelButtonText: 'Cancelar',
														showCancelButton: true,
														confirmButtonColor: '#F64E60'
													}"
													(confirm)="reuse(row)"
												>
													<div class="icon-circle bg-info text-center align-middle pt-info-button">
														<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a *ngIf="permissions.getPermission('40-18-39').asignado && row.estadoSii == 5"
													class="primary edit mr-1 mrless"
													ngbTooltip="Reenviar Email Validación"
													[swal]="{
														title: 'Confirmación',
														text: 'El correo de validación se enviará a la casilla registrada en el sii, ¿Desea Continuar?',
														confirmButtonText: 'Continuar',
														cancelButtonText: 'Cancelar',
														showCancelButton: true,
														confirmButtonColor: '#F64E60'}"
													(confirm)="resendEmailSii(row)">
													<div class="icon-circle bg-success text-center align-middle pt-info-button">
														<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<span class="badge badge-light imported-badge font-italic" *ngIf="row.folioReutilizado">Folio reutilizado</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="col-auto">Elementos por página</div>
												<div class="mr-5">
													<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="datatable-footer">
														<option *ngFor="let option of page.pageSizes" [value]="option"></option>
													</ng-select>
												</div>
												<div class="ml-5 col-auto divisor-footer">
													<div class="page-count">{{ rowCount | number:'1.0-0':'es-CL' }} Elementos totales</div>
												</div>
												<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="table.onFooterPage($event)"> </datatable-pager>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>
									<!-- fin seccion tabla seccion tabla -->

									<!-- tabla movil -->
									<ngx-datatable
										#tableMobile
										*ngIf="componentStarted"
										class="material desktop-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="70"
										[rowHeight]="70"
										fxFlex="auto"
										[perfectScrollbar]="configScroll"
										[selectionType]="'checkbox'"
										[selected]="selected"
										(selected)="onSelect($event)"
										[rowIdentity]="getId"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										[scrollbarH]="true"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
									>
										<!-- Row Detail Template -->
										<ngx-datatable-row-detail [rowHeight]="70" #myDetailRow>
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
												<div class="text-wrap">{{ row.nombreTipoDte }} , Cliente:{{ row.razonSocial ? row.razonSocial : "No disponible" }} , Folio: {{ row.folio }} , Monto: {{ row.total | currency : "$ " : "symbol" : "1.0-0" : "es" }} , Fecha: {{ row.fecha | date : "dd/MM/yyyy" }}</div>
											</ng-template>
										</ngx-datatable-row-detail>
										<!--Checkbox
										<ngx-datatable-column [width]="30" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
											<ng-template ngx-datatable-header-template let-value="value">
												<input type="checkbox" class="customCheckbox" [checked]="selectedAllItemsInPage[page.pageNumber]" (change)="selectAll($event)" />
											</ng-template>
											<ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected" let-onCheckboxChangeFn="onCheckboxChangeFn">
												<input type="checkbox" class="customCheckbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
											</ng-template>
										</ngx-datatable-column>-->
										<ngx-datatable-column [width]="30" [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false">
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
												<a [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded" title="Expand/Collapse Row" (click)="toggleExpandRow(row)" class="desktop-hidden"> </a>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="Razón Social" [flexGrow]="3.5" [sortable]="false" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Documento</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment"> Folio: {{ row.folio }}</span>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column [cellTemplate]="semaforo" [sortable]="false" name="Estado" [flexGrow]="4" [resizeable]="false"></ngx-datatable-column>
										<ngx-datatable-column name="Acciones" [flexGrow]="3" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<div class="action-container">
													<div class="main-action-button" (click)="toggleActions(row)" *ngIf="!row.showActions">
														<fa-icon [icon]="row.showActions ? 'minus' : 'list'"></fa-icon>
													</div>

													<div class="action-buttons action-buttons-client" [ngClass]="{ show: row.showActions }">
														<a [routerLink]="" ngbTooltip="Enviar correo" class="primary edit mr-1 mrless" id="mantenedor-dte-exportacion.component_Enviar_correo" (click)="openDocumentSenderModal(dteSenderModal, row)" *ngIf="permissions.getPermission('40-18-20').asignado">
															<div class="icon-circle bg-success text-center align-middle pt-email-button">
																<fa-icon icon="envelope" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<div ngbDropdown class="dropdownBotoneraLinea" container="body">
															<a [routerLink]="" title="Descarga Documento" ngbTooltip="Descarga Documento" class="success edit mr-1 mrless" ngbDropdownToggle id="dropdownDoc" container="body" *ngIf="permissions.getPermission('40-18-22').asignado">
																<div class="icon-circle bg-danger text-center align-middle pt-file-button">
																	<fa-icon icon="file-pdf" class="fa-lg text-white"></fa-icon>
																</div>
															</a>
															<div ngbDropdownMenu aria-labelledby="dropdownDoc">
																<button ngbDropdownItem (click)="downloadPDF(row)" *ngIf="permissions.getPermission('40-18-22').asignado">Descarga PDF</button>
																<button ngbDropdownItem (click)="downloadXml(row)" *ngIf="permissions.getPermission('40-18-24').asignado">Descargar XML</button>
															</div>
														</div>
														<a [routerLink]="" ngbTooltip="Trazabilidad" class="primary edit mr-1 mrless" id="mantenedor-dte-exportacion.component_Trazabilidad" (click)="openTraceShowModal(dteTracesModal, row)" *ngIf="permissions.getPermission('40-18-26').asignado">
															<div class="icon-circle bg-info text-center align-middle pt-list-button">
																<fa-icon icon="list-alt" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a [routerLink]="" ngbTooltip="Detalles" class="primary edit mr-1 mrless" id="mantenedor-dte-exportacion.component_Detalles" (click)="detailOpenModal(dteDetailModal, row)" *ngIf="permissions.getPermission('40-18-28').asignado">
															<div class="icon-circle bg-warning text-center align-middle pt-info-button">
																<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<!-- VERSIONES DE MANTENEDOR DTE EMITIDOS -->
														<a *ngIf="!row.anulado && permissions.getPermission('40-18-30').asignado && row.notaCreditoHabilitada && row.codigoTipoDte == 110" [routerLink]="" container="body" ngbTooltip="Generar Nota Credito Exportación" class="danger edit mr-1 mrless" (click)="openAnularDteModal(anularNCDteExportModal, row)">
															<div class="icon-circle bg-danger text-center align-middle pt-null-button">
																<fa-icon icon="file-alt" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a *ngIf="!row.anulado && permissions.getPermission('40-18-31').asignado && row.notaDebitoHabilitada && row.codigoTipoDte == 112" [routerLink]="" container="body" ngbTooltip="Generar Nota Debito Exportación" class="danger edit mr-1 mrless" (click)="openAnularDteModal(anularNDDteExportModal, row)">
															<div class="icon-circle bg-danger text-center align-middle pt-null-button">
																<fa-icon icon="file-alt" class="fa-lg text-white"></fa-icon>
															</div>
														</a>

														<a [routerLink]="" ngbTooltip="Reenviar Documento al SII" class="primary edit mr-1 mrless" id="mantenedor-dte-exportacion.component_Reenviar_Documento_al_SII" (click)="resendDte(row)" *ngIf="permissions.getPermission('40-18-38').asignado && row.estadoSii == 8 && !row.folioReutilizado">
															<div class="icon-circle bg-info text-center align-middle pt-info-button">
																<fa-icon icon="recycle" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a
															*ngIf="permissions.getPermission('40-18-39').asignado && row.estadoSii == 5"
															class="primary edit mr-1 mrless"
															ngbTooltip="Reenviar Email Validación"
															[swal]="{
																title: 'Confirmación',
																text: 'El correo de validación se enviará a la casilla registrada en el sii, ¿Desea Continuar?',
																confirmButtonText: 'Continuar',
																cancelButtonText: 'Cancelar',
																showCancelButton: true,
																confirmButtonColor: '#F64E60'
															}"
															(confirm)="resendEmailSii(row)"
														>
															<div class="icon-circle bg-success text-center align-middle pt-info-button">
																<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
													</div>
												</div>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="row" style="width: 100%">
													<div class="col-12 mb-2 ml-3 text-center mt-2">
														<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tableMobile.onFooterPage($event)"> </datatable-pager>
													</div>
													<div class="col-12 d-flex justify-content-center">
														<span class="mr-2 mt-3">Elementos por página</span>

														<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="body">
															<option *ngFor="let option of page.pageSizes" [value]="option"></option>
														</ng-select>

														<span class="ml-4 mt-3"> Página {{ curPage }} de {{ getTotalPages(rowCount, pageSize) }} </span>
													</div>
												</div>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</div>

<ng-template #semaforo let-row="row">
	<app-semaforo-estado-dte [row]="row"></app-semaforo-estado-dte>
</ng-template>

<ng-template #dteDetailModal let-d="dismiss" id="detail-modal">
	<div class="modal-content">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Detalle de {{ dteToShow.nombreTipoDte}} - N° {{ completeDteToShow.dteExportacion.folio }}</div>
				<div class="modal-wizard-desc">Detalles del documento seleccionado</div>
			</div>
		</div>
		<div class="modal-body">
			<!-- client data section -->
			<div class="row form-group mx-auto" id="details-client">
				<h4>Datos del Cliente</h4>
				<div class="col-12">
					<div class="row">
						<table class="detail-table">
							<tr>
								<td>Razón Social</td>
								<td>
									{{
										completeDteToShow.clienteInternacional.razonSocial
											? completeDteToShow.clienteInternacional.razonSocial
											: "No
                                    disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>Giro</td>
								<td>
									{{
										completeDteToShow.clienteInternacional.giro
											? completeDteToShow.clienteInternacional.giro
											: "No
                                    disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>País</td>
								<td>
									{{
										completeDteToShow.clienteInternacional.nombrePais
											? completeDteToShow.clienteInternacional.nombrePais
											: "No
                                    disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>Ciudad</td>
								<td>
									{{
										completeDteToShow.clienteInternacional.ciudad
											? completeDteToShow.clienteInternacional.ciudad
											: "No
                                    disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>Dirección</td>
								<td>{{ completeDteToShow.clienteInternacional.direccionCalle ? completeDteToShow.clienteInternacional.direccionCalle + " " + completeDteToShow.clienteInternacional.direccionNumero : "No disponible" }}</td>
							</tr>
							<tr>
								<td>Correo Facturación</td>
								<td>
									{{
										completeDteToShow.clienteInternacional.correo
											? completeDteToShow.clienteInternacional.correo
											: "No
                                    disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>Fecha Emisión</td>
								<td>{{ dteToShow.fecha | date : "dd/MM/yyyy" }}</td>
							</tr>
							<tr *ngIf="dteToShow.fechaVencimiento">
								<td>Fecha Vencimiento</td>
								<td>{{ dteToShow.fechaVencimiento | date : "dd/MM/yyyy" }}</td>
							</tr>
							<tr *ngIf="dteToShow.estadoAcuse">
								<td>Estado Acuse</td>
								<td>{{ dteToShow.descripcionEstadoAcuse }}</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
			<hr />
			<!-- invoice export section -->
			<div class="row form-group mx-auto" id="export-data">
				<h4>Datos de Exportación</h4>
				<div class="col-12">
					<div class="row">
						<table class="detail-table">
							<tr>
								<td>Modalidad de Venta</td>
								<td>
									{{
										completeDteToShow.dteExportacion.modalidadVentaGlosa
											? completeDteToShow.dteExportacion.modalidadVentaGlosa
											: "No
                                    disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>Cláusula de Venta</td>
								<td>
									{{
										completeDteToShow.dteExportacion.clausulaVentaGlosa
											? completeDteToShow.dteExportacion.clausulaVentaGlosa
											: "No
                                    disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>Puerto Embarque</td>
								<td>
									{{
										completeDteToShow.dteExportacion.nombrePuertoEmbarque
											? completeDteToShow.dteExportacion.nombrePuertoEmbarque
											: "No
                                    disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>País Destino</td>
								<td>
									{{
										completeDteToShow.dteExportacion.nombrePaisDestino
											? completeDteToShow.dteExportacion.nombrePaisDestino
											: "No
                                    disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>Puerto Desembarque</td>
								<td>
									{{
										completeDteToShow.dteExportacion.nombrePuertoDestino
											? completeDteToShow.dteExportacion.nombrePuertoDestino
											: "No
                                    disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>Territorio Desembarque</td>
								<td>
									{{
										completeDteToShow.dteExportacion.territorioDesembarque
											? completeDteToShow.dteExportacion.territorioDesembarque
											: "No
                                    disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>Vía Transporte</td>
								<td>
									{{
										completeDteToShow.dteExportacion.viaTransporte
											? completeDteToShow.dteExportacion.viaTransporte
											: "No
                                    disponible"
									}}
								</td>
							</tr>
							<tr>
								<td>Tipo de Cambio</td>
								<td>{{ dteToShow.tipoCambio | currency : "$ " : "symbol" : "1.0-2" : "es" }}</td>
							</tr>
							<tr>
								<td>Moneda</td>
								<td>{{ dteToShow.tipoMoneda ? dteToShow.tipoMoneda : "No disponible" }}</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
			<!-- invoice packages export data -->
			<div class="row form-group mx-auto" id="packages-data">
				<h4>Bultos</h4>
				<div class="col-12">
					<div class="row">
						<div class="col-4">Tipo de Bulto</div>
						<div class="col-4">Marca/Container</div>
						<div class="col-4 text-right">Cantidad</div>
					</div>
					<div class="row" id="details-dte">
						<ng-container *ngFor="let bulto of completeDteToShow.bultos" class="col-12">
							<div class="col-4" *ngIf="dteToShow.codigoTipoDte != 43">
								<p>
									{{ bulto.nombreTipoBulto ? bulto.nombreTipoBulto : "No disponible" }}
								</p>
							</div>
							<!-- <div class="col-9" *ngIf="dteToShow.codigoTipoDte == 43">
                                    <p>
                                        {{detalle.cantidad}} * {{detalle.descripcion}} 
                                    </p>
                                </div> -->
							<div class="col-4">
								<p>
									{{ bulto.marcas ? bulto.marcas : bulto.idContainer ? bulto.idContainer : "No disponible" }}
								</p>
							</div>
							<div class="col-4">
								<p class="text-right">
									{{ bulto.cantidadBultos }}
								</p>
							</div>
						</ng-container>
					</div>
					<hr />
				</div>
			</div>
			<!-- invoice details section -->
			<div class="row form-group mx-auto">
				<h4>Detalles</h4>
				<div class="col-12">
					<div class="row" id="details-dte">
						<ng-container *ngFor="let detalle of completeDteToShow.detalledtes" class="col-12">
							<div class="col-9">
								<p>{{ detalle.cantidad }} * {{ detalle.nombre }}</p>
							</div>
							<div class="col-3">
								<p class="text-right">
									{{ detalle.total | currency : "$ " : "symbol" : "1.0-2" : "es" }}
								</p>
							</div>
						</ng-container>
					</div>
					<hr />
				</div>
			</div>

			<!-- totals section -->
			<div class="row form-group mx-auto">
				<div class="col-4" *ngIf="dteToShow.observaciones">
					<div class="row" id="details-observaciones">
						<div class="col-12">
							<h4 style="margin-left: -15px">Observaciones</h4>
							<p>{{ dteToShow.observaciones ? dteToShow.observaciones : "" }}</p>
						</div>
					</div>
				</div>

				<div [ngClass]="{ 'col-8': dteToShow.observaciones, 'col-12': !dteToShow.observaciones }">
					<div class="row" id="details-total-dte">
						<div class="offset-5 col-4" *ngIf="completeDteToShow.descuentoGlobal">
							<p class="text-right font-weight-bold">Descuento Global ( - )</p>
						</div>
						<div class="col-3" *ngIf="completeDteToShow.descuentoGlobal">
							<p class="text-right font-weight-bold">
								{{ completeDteToShow.descuentoGlobal | currency : "$ " : "symbol" : "1.0-2" : "es" }}
							</p>
						</div>
						<div class="offset-7 col-2">
							<p class="text-right font-weight-bold">Bienes</p>
						</div>
						<div class="col-3">
							<p class="text-right font-weight-bold">
								{{ completeDteToShow.dteExportacion.totalValorBienes | currency : "$ " : "symbol" : "1.0-2" : "es" }}
							</p>
						</div>
						<div class="offset-7 col-2">
							<p class="text-right font-weight-bold">Flete</p>
						</div>
						<div class="col-3">
							<p class="text-right font-weight-bold">
								{{ completeDteToShow.dteExportacion.flete | currency : "$ " : "symbol" : "1.0-2" : "es" }}
							</p>
						</div>
						<div class="offset-7 col-2">
							<p class="text-right font-weight-bold">Seguro</p>
						</div>
						<div class="col-3">
							<p class="text-right font-weight-bold">
								{{ completeDteToShow.dteExportacion.seguro | currency : "$ " : "symbol" : "1.0-2" : "es" }}
							</p>
						</div>
						<div class="offset-5 col-4" *ngIf="completeDteToShow.dteExportacion.codigoTipoDte == 43">
							<p class="text-right font-weight-bold text-nowrap">Comisiones y Cargos</p>
						</div>
						<div class="offset-5 col-4">
							<p class="text-right font-weight-bold text-nowrap">Clausula de Venta</p>
						</div>
						<div class="col-3">
							<p class="text-right font-weight-bold">
								{{ completeDteToShow.dteExportacion.total | currency : "$ " : "symbol" : "1.0-2" : "es" }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-success" data-dismiss="modal" (click)="d('Cross click')">Volver</button>
		</div>
	</div>
</ng-template>

<ng-template #dteTracesModal let-d="dismiss">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" id="exampleModalLabel1">Trazabilidad</h5>
		</div>
		<form #TrazaForm="ngForm">
			<div class="modal-body">
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Documento:</label>
					<div class="col-9">
						<input type="text" value="{{ dteToShow.nombreTipoDte }} N° {{ dteToShow.folio }}" disabled name="ngModel" class="form-control" id="fecha" />
					</div>
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<table class="table table-bordered" [hidden]="tracesToShow.length == 0">
						<thead>
							<tr>
								<th>Fecha</th>
								<th>Descripción</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let traza of tracesToShow">
								<td>
									{{ traza.fecha | date : "dd/MM/yyyy HH:mm" }}
								</td>
								<td style="overflow-wrap: anywhere">{{ traza.descripcion }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div *ngIf="mostrarMsgSii" class="text-alertSii">
				<a href="https://www.youtube.com/watch?v=vt_Bz2Jsst8" target="_blank" rel="noopener noreferrer">
					Configure el SII para obtener detalles del estado de este documento.
				</a>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-success" data-dismiss="modal" (click)="d('Cross click')">Volver</button>
			</div>
		</form>
	</div>
</ng-template>

<ng-template #dteSenderModal let-d="dismiss" let-c="close">
	<form [formGroup]="senderForm" (ngSubmit)="onSubmitSenderForm()" #senderFormRef="ngForm">
		<div class="modal-lg">
			<div class="modal-header">
				<div class="modal-wizard-label">
					<div class="modal-wizard-title">Envío de documentos por Correo</div>
					<div class="modal-wizard-desc">Indique correo y seleccione los documentos a enviar</div>
				</div>
				<!-- <h5 class="modal-title" id="titleModalSender"></h5> -->
				<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body" *ngIf="selected.length > 0 && selectedItem == undefined">
				<table class="table">
					<tr>
						<th>Folio</th>
						<th>Cliente</th>
						<th>Monto</th>
					</tr>
					<tr *ngFor="let dte of selected">
						<td>{{ dte.folio }}</td>
						<td>{{ dte.razonSocial }}</td>
						<td>{{ dte.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}</td>
					</tr>
				</table>
			</div>
			<div class="modal-body" *ngIf="selectedItem != undefined">
				<table class="table">
					<tr>
						<th>Folio</th>
						<th>Cliente</th>
						<th>Monto</th>
					</tr>
					<tr>
						<td>{{ selectedItem.folio }}</td>
						<td>{{ selectedItem.razonSocial }}</td>
						<td>{{ selectedItem.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}</td>
					</tr>
				</table>
			</div>
			<div class="modal-body">
				<div class="form-group row mx-auto">
					<label for="email" class="col-3 label-control">Dirección de Correo</label>
					<div class="col-9">
						<input
							type="email"
							name="email"
							class="form-control"
							formControlName="receiverEmail"
							autocomplete="off"
							[ngClass]="{
								'is-invalid': (senderFormRef.submitted && senderForm.controls['receiverEmail'].invalid) || (senderForm.controls['receiverEmail'].touched && senderForm.controls['receiverEmail'].invalid)
							}"
						/>
						<div class="invalid-feedback" *ngIf="senderFormRef.submitted && (senderForm.controls['receiverEmail'].invalid || senderForm.controls['receiverEmail'].touched || senderForm.controls['receiverEmail'].dirty)">
							<div *ngIf="senderForm.get('receiverEmail').errors?.required">Campo Obligatorio</div>
							<!-- <div *ngIf="senderForm.get('receiverEmail').errors?.email||senderForm.get('receiverEmail').errors?.pattern">Ingrese un email válido</div> -->
							<div *ngIf="senderForm.get('receiverEmail').hasError('toAddress')">Ingrese un email válido</div>
							<div *ngIf="senderForm.get('receiverEmail').errors?.maxlength">Ingrese menos de 320 carácteres</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto">
					<label for="ccEmail" class="col-3 label-control">CC</label>
					<div class="col-9">
						<input
							type="email"
							name="ccEmail"
							class="form-control"
							formControlName="ccEmail"
							autocomplete="new-password"
							[ngClass]="{
								'is-invalid': (senderFormRef.submitted && senderForm.controls['ccEmail'].invalid) || (senderForm.controls['ccEmail'].touched && senderForm.controls['ccEmail'].invalid)
							}"
						/>
						<div class="invalid-feedback" *ngIf="senderFormRef.submitted && (senderForm.controls['ccEmail'].invalid || senderForm.controls['ccEmail'].touched || senderForm.controls['ccEmail'].dirty)">
							<div *ngIf="senderForm.get('ccEmail').errors?.required">Campo Obligatorio</div>
							<!-- <div *ngIf="senderForm.get('ccEmail').errors?.email||senderForm.get('ccEmail').errors?.pattern">Ingrese un email válido</div> -->
							<div *ngIf="senderForm.get('ccEmail').hasError('toAddress')">Ingrese un email válido</div>
							<div *ngIf="senderForm.get('ccEmail').errors?.maxLength">Ingrese menos de 320 carácteres</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto">
					<label for="ccoEmail" class="col-3 label-control">CCO</label>
					<div class="col-9">
						<input
							type="email"
							name="ccoEmail"
							class="form-control"
							formControlName="ccoEmail"
							autocomplete="new-password"
							[ngClass]="{
								'is-invalid': (senderFormRef.submitted && senderForm.controls['ccoEmail'].invalid) || (senderForm.controls['ccoEmail'].touched && senderForm.controls['ccoEmail'].invalid)
							}"
						/>
						<div class="invalid-feedback" *ngIf="senderFormRef.submitted && (senderForm.controls['ccoEmail'].invalid || senderForm.controls['ccoEmail'].touched || senderForm.controls['ccoEmail'].dirty)">
							<div *ngIf="senderForm.get('ccoEmail').errors?.required">Campo Obligatorio</div>
							<!-- <div *ngIf="senderForm.get('ccoEmail').errors?.email||senderForm.get('ccoEmail').errors?.pattern">Ingrese un email válido</div> -->
							<div *ngIf="senderForm.get('ccoEmail').hasError('toAddress')">Ingrese un email válido</div>
							<div *ngIf="senderForm.get('ccoEmail').errors?.maxLength">Ingrese menos de 320 carácteres</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto">
					<div class="col-6">
						<div class="row">
							<div class="col-6 label-control mr-5" for="pdfCheckbox">Enviar PDF</div>
							<div class="col-5">
								<input type="checkbox" formControlName="sendPdfCheckbox" class="form-check-input" id="pdfCheckbox" />
							</div>
						</div>
					</div>
					<div class="col-6">
						<div class="row">
							<div class="col-5 label-control">Enviar XML</div>
							<div class="col-7">
								<input type="checkbox" formControlName="sendXmlCheckbox" class="form-check-input" id="xmlCheckbox" />
							</div>
						</div>
					</div>
					<div class="offset-3 col-9 pl-4">
						<!-- <div class="invalid-feedback-group invalid-feedback row pl-3" *ngIf="senderFormRef.submitted && (senderForm.controls['sendPdfCheckbox'].value == false && senderForm.controls['sendXmlCheckbox'].value == false)">
                            <div>Favor indicar por lo menos un documento a enviar</div>
                       </div> -->
						<div class="invalid-feedback-group invalid-feedback row pl-3" *ngIf="senderForm.errors?.mailRepeated && (senderForm.touched || senderForm.dirty || senderFormRef.submitted)">
							<div>Favor no repetir direcciones de correo</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto">
					<label for="email" class="col-3 label-control">Comentarios</label>
					<div class="col-9">
						<textarea
							type="text"
							name="comentarios"
							class="form-control"
							formControlName="comments"
							autocomplete="off"
							[ngClass]="{
								'is-invalid': (senderFormRef.submitted && senderForm.controls['comments'].invalid) || (senderForm.controls['comments'].touched && senderForm.controls['comments'].invalid)
							}"
						></textarea>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="form-group position-relative has-icon-left mb-0">
					<button type="submit" id="add-contact-item" class="btn btn-success add-contact-item">
						<i class="la la-paper-plane-o d-lg-none"></i>
						<span class="d-none d-lg-block">Enviar</span>
					</button>
					<button type="button" class="btn btn-secondary ml-3" (click)="c('Cross click')">
						<span class="d-none d-lg-block">Cerrar</span>
					</button>
				</div>
			</div>
		</div>
	</form>
</ng-template>
<ng-template #anularNCDteExportModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Nota de Crédito de DTE Exportación</div>
				<div class="modal-wizard-desc">Indique tipo de Nota de Crédito e indique los detalles</div>
			</div>
			<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<app-anulador-dte #anularDteComponent [receivedDte]="dteToNullify" [dteReferences]="dteToNullifyReferences" (sendCloseRequestEmitter)="closeAnularDteModal()" (newCreditNoteRequest)="newCreditNote($event)"> </app-anulador-dte>
	</div>
</ng-template>
<ng-template #anularNDDteExportModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Nota de Débito de DTE Exportación</div>
				<div class="modal-wizard-desc">Indique tipo de Nota de Débito e indique los detalles</div>
			</div>
			<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<app-anulador-dte #anularDteComponent [receivedDte]="dteToNullify" [dteReferences]="dteToNullifyReferences" [DebitoMode]="true" (sendCloseRequestEmitter)="closeAnularDteModal()" (newDebitNoteRequest)="newDebitNoteNullification($event)"></app-anulador-dte>
	</div>
</ng-template>
